import { api } from "./api";
import { callAuthApi } from "../helpers";

/* const callApiSaqsCreate = async (data) => {
  //console.log(11);
  if (callAuthApi()) {
    //console.log(22);

    return await api.service("api/saqs").create(data);
  } else {
    //console.log(33);
    return null;
  }
};

const callApiSaqsPatch = async (saqId, data) => {
  if (callAuthApi()) {
    return await api.service("api/saqs").patch(saqId, data);
  } else {
    return null;
  }
};

const callApiSaqsGet = async (saqId) => {
  if (callAuthApi()) {
    return await api.service("api/saqs").get(saqId);
  } else {
    return null;
  }
}; */

const callApiGetUsersUsingUserId = async (userId) => {
  if (callAuthApi()) {
    // console.log("123 data.callApiGetUsersUsingUserId", data, data.businessId);
    return await api.service("users").get(userId);
  } else {
    return null;
  }
};

const callApiUsersList = async (data) => {
  if (callAuthApi()) {
    console.log("123 data.businessId", data, data.businessId);
    return await api
      .service("api/users")
      .find({ query: { businessId: data.businessId } });
  } else {
    return null;
  }
};

const callApiUpdateUser = async (data) => {
  if (callAuthApi()) {
    console.log("*********** callApiUpdateUser", data);

    return await api.service("api/users").create(data);
  } else {
    return null;
  }
};

const callApiFetchCompanyUserList = async (data) => {
  if (callAuthApi()) {
    console.log(
      "*********** callApiFetchCompanyUserList 123",
      data,
      data.businessId
    );

    return await api.service("api/users").find({
      query: { businessId: data.businessId },
    });
  } else {
    return null;
  }
};

/* const callApiSaqsDelete = async (saqId) => {
  if (callAuthApi()) {
    console.log("callApiSaqsDelete");
    return await api.service("api/saqs").remove(saqId);
  } else {
    return null;
  }
}; */

/* const callApiDownloadSaqPdf = async (data) => {
  if (callAuthApi()) {
    return await api.service("api/generate-saq-pdf").create({ query: data });
  } else {
    return null;
  }
}; */

export {
  callApiGetUsersUsingUserId,
  callApiUsersList,
  callApiUpdateUser,
  callApiFetchCompanyUserList,
};
